import https from "../../services/http";

export const getLoginSectionsAPI = () =>
  https.get("/utils-service/loginSection");

export const getImageSignaturesAPI = () =>
  https.get("/user-service/cookie/part-image");
